import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps, useModal } from '@pcmp/react-providers';
import { ModalHeader, Sheets, ModalBody } from '@ingka/modal';
import { useContentTracking } from '@/lib/hooks/tracking';
import ListView, { ListViewItem } from '@ingka/list-view';

const ReportIssueSider: FC<ModalComponentBaseProps> = ({
  handleDismiss,
  ...rest
}) => {
  // Hooks
  const trackContent = useContentTracking();
  const { t } = useTranslation();
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    trackContent('report-issue', { type: 'sider' });
  }, []);

  const goBack = async () => {
    await closeModal(0);
    const { default: HelpCenterSider } = await import('..');

    await openModal({
      component: HelpCenterSider,
      props: {},
    });
  };

  return (
    <Sheets
      {...rest}
      data-testid="reportIssueModal"
      aria-label={t('page.reportIssue.description')}
      footer={null}
      header={
        <ModalHeader
          ariaCloseTxt={t('aria.close')}
          title={t('page.reportIssue.title')}
          backBtnClick={goBack}
        />
      }
    >
      <ModalBody>
        <ListView id="help-center-list">
          <ListViewItem
            data-testid="ticketBtn"
            size="medium"
            inset
            emphasised
            title={t('page.reportIssue.ticket.title')}
            description={t('page.reportIssue.ticket.description')}
            control="link"
            controlIcon="linkOut"
            href="https://now.ingka.com/esc?id=sc_category&sys_id=542cea410bc71510d9b1681b14f8dfa3"
            newWindow="_blank"
            rel="noopener noreferrer nofollow"
          />
          <ListViewItem
            data-testid="adminFaqBtn"
            size="medium"
            inset
            emphasised
            title={t('page.reportIssue.chat.title')}
            description={t('page.reportIssue.chat.description')}
            control="link"
            controlIcon="linkOut"
            href="https://teams.microsoft.com/l/app/49471a10-fdbc-4ffb-b0b8-944f3df985d9?source=app-details-dialog"
            newWindow="_blank"
            rel="noopener noreferrer nofollow"
          />
        </ListView>
      </ModalBody>
    </Sheets>
  );
};

export default ReportIssueSider;
